export var PreviewTypes;
(function (PreviewTypes) {
    PreviewTypes["FREE_TEXT"] = "PREVIEW_TYPE_FREE_TEXT";
    PreviewTypes["PDF"] = "PREVIEW_TYPE_PDF";
    PreviewTypes["DOCX"] = "PREVIEW_TYPE_DOCX";
    PreviewTypes["COMPOSED"] = "PREVIEW_TYPE_COMPOSED";
    PreviewTypes["UNKNOWN"] = "PREVIEW_TYPE_UNKNOWN";
})(PreviewTypes || (PreviewTypes = {}));
